import cn from "classnames";
import isEmpty from "lodash/isEmpty";
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult
} from "react-beautiful-dnd";
import ClipLoader from "react-spinners/ClipLoader";

import { DragDropListProps } from "./DragDropList.types";

import styles from "./DragDropList.module.scss";

const DragDropList = <T extends { id: string }>({
  isLoading,
  droppableId,
  data,
  emptyText,
  isDragDisabled = false,
  direction = "vertical",
  onChange,
  renderItem,
  keyForReorder: _keyForReorder
}: DragDropListProps<T>) => {
  const onDragEnd = (dropResult: DropResult) => {
    const { destination, source, draggableId } = dropResult;

    if (!destination) {
      return;
    }

    const { index: fromIndex } = source;
    const { index: toIndex } = destination;

    if (fromIndex !== toIndex) {
      onChange({ draggableId, fromIndex, toIndex });
    }
  };

  if (isLoading) {
    return (
      <div className={styles["drag-drop-list__content"]}>
        <ClipLoader size={30} color="#fb3973" />
      </div>
    );
  }

  if (isEmpty(data) && emptyText) {
    return <div className={styles["drag-drop-list__content"]}>{emptyText}</div>;
  }

  return (
    <div className={styles["drag-drop-list"]}>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId={droppableId} direction={direction}>
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className={cn({
                [styles["drag-drop-list_itemsContainer__horizontal"]]:
                  direction === "horizontal"
              })}
            >
              {data.map((item: T, index: number) => (
                <Draggable
                  key={item.id}
                  draggableId={item.id}
                  index={index}
                  isDragDisabled={isDragDisabled}
                >
                  {(draggableProvided) => (
                    <div
                      ref={draggableProvided.innerRef}
                      {...draggableProvided.draggableProps}
                      {...draggableProvided.dragHandleProps}
                    >
                      {renderItem(item)}
                    </div>
                  )}
                </Draggable>
              ))}

              {provided.placeholder as any}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default DragDropList;
